export const GET_ENTERPRISE_DETAILS = 'GET_ENTERPRISE_DETAILS';
export const LIST_ENTERPRISE = 'LIST_ENTERPRISE';
